import React from 'react';
import './Loader.css';

const Loader = () => (
  <div className='loader-container'>
    <div className='spinner'></div>
    <p className='loader-text'>טוען נתונים...</p>
  </div>
);

export default Loader;
